import CookieConsentLink from './CookieConsentLink'

export default CookieConsentLink
